<template>
  <v-layout v-bind="binding">
    <v-layout v-for="(field, index) in fields" v-bind:key="index">
      <v-flex xs4>
        <v-text-field
          v-if="field.value === true"
          disabled
          v-model="field.name"
        ></v-text-field>
      </v-flex>
      <v-flex xs2>
        <v-icon v-if="field.value === true" @click="fieldList(index)">
          remove_circle
        </v-icon>
      </v-flex>
    </v-layout>
    <!-- <v-layout>
        <v-flex
          xs12
          md4
        >
          <v-text-field
            v-if="fname"
            label="First name"
            box
            disabled
          >
          </v-text-field>
          <v-icon right @click="itemList">cancel</v-icon>
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-text-field
            label="Middle name"
             box
             disabled
          ></v-text-field>
        </v-flex>

        <v-flex
          xs12
          md4
        >
          <v-text-field
            label="Last Name"
            box
            disabled
          ></v-text-field>
        </v-flex>
      </v-layout> -->
    <!-- <v-layout>
        <v-flex
        xs12
        md6
        >
        <v-text-field
          label="Email"
          box
          disabled
        ></v-text-field>
        </v-flex>

        <v-flex
        xs12
        md6
        >
        <v-text-field
          label="Phone"
          box
          disabled
        ></v-text-field>
        </v-flex>
      </v-layout> -->
    <div v-if="section">
      <span class="headline">Address</span>
      <v-icon color="black" @click="deleteSection">
        cancel
      </v-icon>
      <div class="previous">
        <v-layout class="">
          <v-flex xs12 md4>
            <v-text-field label="Country" box disabled></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field label="Division" box disabled></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field label="District" box disabled></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md4>
            <v-text-field label="Area" box disabled></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field label="Road No." box disabled></v-text-field>
          </v-flex>

          <v-flex xs12 md4>
            <v-text-field label="House No." box disabled></v-text-field>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <v-layout v-bind="binding">
      <v-card class="mt-5">
        <v-card-title class="grey lighten-4">
          <span class="material-icons">
            contacts
          </span>
          <span>Option</span>
          <v-spacer></v-spacer>
          <span class="black--text">Add Section</span>
          <v-icon color="black" @click="addSection">
            add_circle_outline
          </v-icon>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-layout>
            <h3 class="heading">Add More Fields</h3>
          </v-layout>
          <!-- <v-layout 
          v-for="(button,index) in buttons"
          :key="index"
          row
          wrap
          >
            <div>
              <v-btn 
              class="button" 
              v-if="button.value"
              >{{button.name}}
                <v-icon right @click="buttonList(index)">add</v-icon>
              </v-btn>
            </div>
          </v-layout> -->
          <v-flex xs12>
            <v-form v-model="valid" ref="form">
              <v-layout row wrap>
                <v-flex v-for="(button, index) in buttons" :key="index">
                  <v-btn
                    class="button"
                    v-if="button.value"
                    @click="buttonList(index)"
                    >{{ button.name }}
                    <v-icon right>add_circle_outline</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-layout>
</template>

<script>
export default {
  props: ["contactInfo"],
  data: () => ({
    valid: false,
    section: false,
    fields: [
      { id: 1, name: "First Name", value: true },
      { id: 2, name: "Middle Name", value: true },
      { id: 3, name: "Last Name", value: true },
      { id: 4, name: "Phone", value: true },
      { id: 5, name: "Email", value: true },
    ],
    buttons: [
      { id: 6, name: "First Name", value: false },
      { id: 7, name: "Middle Name", value: false },
      { id: 8, name: "Last Name", value: false },
      { id: 9, name: "Phone", value: false },
      { id: 10, name: "Email", value: false },
    ],
  }),
  created() {
    this.initial();
  },
  computed: {
    binding() {
      const binding = {};

      if (this.$vuetify.breakpoint.mdAndUp) binding.column = true;

      return binding;
    },
  },
  methods: {
    initial() {
      // console.log(this.contactInfo);
      
      if (this.contactInfo.address === true) {
        this.section = true;
      }
      if (this.contactInfo.first_name === true) {
        // console.log(this.fields[0].value);
        this.fields[0].value = true;
        this.buttons[0].value = false;
        // console.log("first_name "+this.fields[0].value);
      }else{
        this.fields[0].value = false;
        this.buttons[0].value = true;
      }
      if (this.contactInfo.middle_name === true) {
        //  console.log(this.fields[1].value);
        this.fields[1].value = true;
        this.buttons[1].value = false;
        // console.log("middle_name "+this.fields[1].value);
      }else{
        this.fields[1].value = false;
        this.buttons[1].value = true;
      }
      if (this.contactInfo.last_name === true) {
        this.fields[2].value = true;
        this.buttons[2].value = false;
        // console.log("last_name "+this.fields[2].value);
      }else{
        this.fields[2].value = false;
        this.buttons[2].value = true;
      }
      if (this.contactInfo.phone === true) {
        this.fields[3].value = true;
        this.buttons[3].value = false;
      }else{
        this.fields[3].value = false;
        this.buttons[3].value = true;
      }
       if (this.contactInfo.email === true) {
        //  console.log(this.fields[4].value);
        this.fields[4].value = true;
        this.buttons[4].value = false;
        // console.log("email "+this.fields[4].value);
      }else{
        this.fields[4].value = false;
        this.buttons[4].value = true;
      }
      // console.log(this.fields);
    },
    addSection() {
      this.section = true;
      this.$emit("change", "add");
    },
    deleteSection() {
      this.section = false;
      this.$emit("change", "delete");
    },
    buttonList(i) {
      if (i == 0) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 1) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 2) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 3) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 4) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 5) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 6) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 7) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 8) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else if (i == 9) {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      } else {
        this.buttons[i].value = false;
        this.fields[i].value = true;
      }
      this.$emit("change", this.buttons[i].id);
    },
    fieldList(i) {
      if (i == 0) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 1) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 2) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 3) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 4) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 5) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 6) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 7) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 8) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else if (i == 9) {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      } else {
        this.fields[i].value = false;
        this.buttons[i].value = true;
      }
      this.$emit("change", this.fields[i].id);
    },
  },
};
</script>
<style scoped>
.previous {
  border: 2px solid;
  padding: 5px;
}
.button {
  font-size: 14px;
  padding: 0.4rem 1.3rem;
  border: none;
  cursor: pointer;
  border-radius: 4px;
  margin: 10px;
  color: black;
  text-transform: none !important;
}
</style>
